import { defineComponent as n, useTemplateRef as f, watch as o, createElementBlock as m, openBlock as d, mergeProps as l, unref as v, renderSlot as T } from "vue";
import { useFocusTrap as B } from "../node_modules/.pnpm/@vueuse_integrations@13.1.0_focus-trap@7.6.4_vue@3.5.13_typescript@5.8.3_/node_modules/@vueuse/integrations/useFocusTrap.js";
import { useOUIAProps as _ } from "./ouia.js";
const I = /* @__PURE__ */ n({
  name: "PfFocusTrap",
  __name: "FocusTrap",
  props: {
    active: { type: Boolean },
    paused: { type: Boolean },
    focusTrapOptions: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  setup(t) {
    const e = t, s = _({ id: e.ouiaId, safe: e.ouiaSafe }), p = f("targetRef"), { activate: r, deactivate: u, pause: a, unpause: i } = B(p, {
      immediate: e.active,
      ...e.focusTrapOptions
    });
    return e.paused && a(), o(() => e.active, () => {
      e.active ? r() : u();
    }), o(() => e.paused, () => {
      e.paused ? a() : i();
    }), (c, g) => (d(), m("div", l(v(s), { ref: "targetRef" }), [
      T(c.$slots, "default")
    ], 16));
  }
});
export {
  I as default
};
